import $ from 'jquery';

$(document).ready(function () {
    $('iframe').each(function () {
        const $iframe = $(this);
        const width = $iframe.attr('width');
        const height = $iframe.attr('height');

        if (width && height) {
            // Calculate aspect ratio as percentage
            const aspectRatio = (parseFloat(height) / parseFloat(width)) * 100;

            // Create wrapper div with responsive styling
            const $wrapper = $('<div></div>').css({
                'position': 'relative',
                'width': '100%',
                'padding-bottom': aspectRatio + '%',
                'height': 0,
                'overflow': 'hidden'
            });

            // Style iframe to fill wrapper
            $iframe.css({
                'position': 'absolute',
                'top': 0,
                'left': 0,
                'width': '100%',
                'height': '100%'
            }).removeAttr('width').removeAttr('height');

            // Wrap iframe with the container
            $iframe.wrap($wrapper);
        }
    });
});